import { PhoneNumber, XingIdContactDetailsData } from '../../../../graphql/generated';
import { getDialCodeFromCountryCode } from '../../helpers';

export type ParsedPhoneNumber = {
  countryCode: string;
  number: string;
};

const accountSettingsDataCountryByDialCode = {
  '41': 'CH',
  '43': 'AT',
  '49': 'DE',
};

// we're retrieving the full phone number (country code + phone number) from accountSettings where available country codes can be only DE (+49), AT (+43) or CH (+41)
const parsePhoneFromUserAccountData = (number: string): ParsedPhoneNumber => ({
  countryCode: accountSettingsDataCountryByDialCode[number.slice(1, 3)],
  number: number.slice(3),
});

const PLUS_SIGN_IN_COUNTRY_CODE = 1;

const parsePhoneFromPrivateContactDetails = (privatePhoneNumber: PhoneNumber): ParsedPhoneNumber | null => {
  const countryDialingCode =
    privatePhoneNumber?.countryCode && getDialCodeFromCountryCode(privatePhoneNumber.countryCode);

  if (privatePhoneNumber?.countryCode && countryDialingCode && privatePhoneNumber.phoneNumber) {
    const phoneNumber = privatePhoneNumber.phoneNumber.slice(countryDialingCode.length + PLUS_SIGN_IN_COUNTRY_CODE);

    return { countryCode: privatePhoneNumber.countryCode, number: phoneNumber };
  }

  return null;
};

export const getSavedPhone = (
  accountSettingsPhone: string | undefined | null,
  privateContactDetailsPhone: XingIdContactDetailsData | undefined | null
): ParsedPhoneNumber | null => {
  const parsedAccountSettingsPhone = accountSettingsPhone && parsePhoneFromUserAccountData(accountSettingsPhone);

  if (parsedAccountSettingsPhone && parsedAccountSettingsPhone.countryCode) {
    return parsedAccountSettingsPhone;
  }

  const privateContactDetails = privateContactDetailsPhone?.mobile
    ? privateContactDetailsPhone?.mobile
    : privateContactDetailsPhone?.phone;

  return privateContactDetails ? parsePhoneFromPrivateContactDetails(privateContactDetails) : null;
};
